import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const AddScheduleCall = () => {
    const navigate = useNavigate();
    return (
        <section className='w-full md:py-20 py-8 rounded-xl'>
            <div className="container mx-auto flex flex-col items-center gap-6">
                {/* Text */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className='flex flex-col items-center text-center max-w-xl'
                >
                    <h6 className="text-blue-600 text-base font-medium uppercase mb-2">
                        Start collecting data seamlessly
                    </h6>
                    <p className='text-gray-700 dark:text-gray-300 text-sm md:text-base leading-relaxed'>
                        Speak to one of our experts and begin your sustainability journey today.
                    </p>
                </motion.div>

                {/* Button */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <button 
                        type="button" 
                        className="bg-blue-600 hover:bg-blue-700 dark:bg-green-600 dark:hover:bg-green-700 text-white text-base font-semibold rounded-full px-8 py-3 shadow-md hover:shadow-lg transition-all duration-300"
                        onClick={()=>navigate('/contact')}
                    >
                        Book a demo
                    </button>
                </motion.div>

            </div>
        </section>
    );
}

export default AddScheduleCall;
